import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthMonitor } from '../auth.monitor';
import { SharedModule } from '../shared.module';
import { SkillsGapComponentModule } from './skillsGap/skills-gap.component.module';
import { SkillAssessmentComponent, SkillAssessmentCancelTestDialog } from './skillsMatcher/skill-assessment.component';
import { SkillFitPipe, SkillResultComponent, SkillResultShareDialog, SkillResultViewAllDialog } from './skillsMatcher/skill-result.component';

const routes: Routes = [
	{ path: "Assessment", component: SkillAssessmentComponent, canActivate: [AuthMonitor], data: { authenticate: false, routeName: "Skills Matcher" } },
	{ path: "Result", component: SkillResultComponent, canActivate: [AuthMonitor], data: { authenticate: false, routeName: "Skills Matcher Result" } },
	{ path: "**", redirectTo: "Assessment" }
];

@NgModule({
	imports: [
		SharedModule,
		SkillsGapComponentModule,
		RouterModule.forChild(routes)
	],
	declarations: [
		SkillFitPipe,
		SkillAssessmentComponent,
		SkillAssessmentCancelTestDialog,
		SkillResultComponent,
		SkillResultShareDialog,
		SkillResultViewAllDialog
	],
	exports: []
})
export class SkillProfilerModule { }
